/*
  data: 条件是否需要提供值生效
  word: 使用不同的文字样式
 */

const conditionEnum = {
  LIKE: {
    name: '',
    text: '常规筛选',
    char: '∽',
    data: true
  },
  RANGE: {
    name: 'range',
    text: '区间筛选',
    char: '[-]',
    data: true,
    word: true
  },
  GT: {
    name: 'gt',
    text: '大于某值',
    char: '>',
    data: true
  },
  LT: {
    name: 'lt',
    text: '小于某值',
    char: '<',
    data: true
  },
  EQ: {
    name: 'eq',
    text: '等于某值',
    char: '=',
    data: true
  },
  GE: {
    name: 'ge',
    text: '大于等于某值',
    char: '≥',
    data: true
  },
  LE: {
    name: 'le',
    text: '小于等于某值',
    char: '≤',
    data: true
  },
  NULL: {
    name: 'null',
    text: '空值筛选',
    char: '空',
    word: true
  },
  NOT_NULL: {
    name: 'notNull',
    text: '非空筛选',
    char: '{-}',
    word: true
  },
  OR: {
    name: 'or',
    text: '多值筛选',
    char: 'or',
    data: true
  }
}

export default conditionEnum
